// src/context/AuthProvider.tsx
// Simple AuthProvider - works with both password and Microsoft auth

import { ReactNode, createContext, useState } from 'react';

type Props = {
  children?: ReactNode;
};

type IAuthContext = {
  name: string | null;
  roles: string[] | null;
  email: string | null;
  organizationIds: number[] | null;
  authenticated: boolean;
  setAuthenticated: (newState: boolean) => void;
  setName: (newState: string | null) => void;
  setEmail: (newState: string | null) => void;
  setRoles: (newState: string[] | null) => void;
  setOrganizationIds: (newState: number[] | null) => void;
};

const initialValue: IAuthContext = {
  name: localStorage.getItem('name'),
  email: localStorage.getItem('email'),
  roles: JSON.parse(localStorage.getItem('roles') || 'null'),
  organizationIds: JSON.parse(localStorage.getItem('organizationIds') || 'null'),
  authenticated: JSON.parse(localStorage.getItem('isLoggedIn') || 'false'),
  setAuthenticated: () => {},
  setName: () => {},
  setEmail: () => {},
  setRoles: () => {},
  setOrganizationIds: () => {},
};

const AuthContext = createContext<IAuthContext>(initialValue);

export const AuthProvider = ({ children }: Props) => {
  const [authenticated, setAuthenticated] = useState(initialValue.authenticated);
  const [name, setName] = useState(initialValue.name);
  const [email, setEmail] = useState(initialValue.email);
  const [roles, setRoles] = useState(initialValue.roles);
  const [organizationIds, setOrganizationIds] = useState(initialValue.organizationIds);

  return (
    <AuthContext.Provider
      value={{
        authenticated,
        roles,
        name,
        email,
        organizationIds,
        setEmail,
        setName,
        setAuthenticated,
        setRoles,
        setOrganizationIds,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;